import React from 'react';
import firebase from '../../Utils/Firebase';
import 'firebase/firestore';
import 'firebase/storage';
import styles from './ProdutoDetalhes.module.css';
import { Link, useParams, Navigate } from 'react-router-dom';
import Head from '../Head';
import logoCarregando from '../../Assets/logocantinho.png';

import olho from '../../Assets/eye.svg';
import { useSelector } from 'react-redux';
import Image from '../skeleton/Image';

const ProdutoDetalhes = () => {
  const [produto, setProduto] = React.useState({});
  const [urlImg, setUrlImg] = React.useState({});
  const [carregando, setCarregando] = React.useState(1);
  const [excluir, setExcluir] = React.useState(0);
  const [error, setError] = React.useState(null);
  const usuarioLogado = useSelector((state) => state.usuarioEmail);
  const ed = 'eds_paz@hotmail.com';
  const parans = useParams();
  const id = parans.id;

  function remover() {
    firebase
      .firestore()
      .collection('produtos')
      .doc(id)
      .delete()
      .then(() => {
        setExcluir(1);
      });
  }

  React.useEffect(() => {
    try {
      firebase
        .firestore()
        .collection('produtos')
        .doc(id)
        .get()
        .then((resultado) => {
          setProduto(resultado.data());
          firebase
            .firestore()
            .collection('produtos')
            .doc(id)
            .update('visualizacoes', resultado.data().visualizacoes + 1);

          firebase
            .storage()
            .ref(`img/${resultado.data().foto}`)
            .getDownloadURL()
            .then((url) => {
              setUrlImg(url);
              setCarregando(0);
            });
        });
    } catch (erro) {
      setError('Um erro ocorreu!');
    }
  }, []);

  if (error) return <p>{error}</p>;
  if (produto === null) return null;
  return (
    <>
      <div className={styles.produtoDetalhes}>
        {excluir > 0 ? <Navigate to="/" /> : null}
        {carregando ? (
          <img src={logoCarregando} />
        ) : (
          <div className={`${styles.contentDescricao} animeLeft`}>
            <Head
              title={`Cantinho d' Bolos | ${produto.nome}`}
              description="Esses São nossos produtos."
            />
            <div>
              <div>
                <h1 className={styles.title}>{produto.nome}</h1>
              </div>
              <div className={styles.imagem}>
                <Image src={urlImg} alt="foto" />
              </div>
            </div>
            <div className={styles.descricao}>
              <p className={styles.descricaoParagrafo}>{produto.descricao}</p>
              <div className={styles.gridDescricao}>
                <div className={styles.precoContent}>
                  <p>Pequeno</p> R${' '}
                  <p className={styles.preco}>
                    <span className={styles.price}>{produto.precoP}</span>
                  </p>
                  <p>Médio</p> R${' '}
                  <p className={styles.preco}>
                    {' '}
                    <span className={styles.price}>{produto.precoM}</span>
                  </p>
                  <p>Grande</p> R${' '}
                  <p className={styles.preco}>
                    <span className={styles.price}>{produto.precoG}</span>
                  </p>
                </div>

                {usuarioLogado === produto.usuario ? (
                  <>
                    <div className={styles.olho}>
                      <img src={olho} alt="logo Olho" />
                      <p>{produto.visualizacoes}</p>
                    </div>
                  </>
                ) : (
                  ''
                )}

                {usuarioLogado === produto.usuario ? (
                  <>
                    <div className={styles.btns}>
                      <button className={styles.btnEdt} onClick={remover}>
                        {' '}
                        Remover
                      </button>

                      <Link
                        to={`/editarproduto/${id}`}
                        className={` ${styles.editar}`}
                      >
                        Editar
                      </Link>
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProdutoDetalhes;
